import dayjs from "dayjs";

import { sysConfigStore } from "@/stores/sysConfigStore";

export const addZero = (value: number): string => {
  if (value < 0) {
    return `${value}`;
  }
  return value < 10 ? `0${value}` : `${value}`;
};
//时间戳兼容 秒和毫秒
export const formatDate = (time: number, type = 2): string => {
  if (!time) return "";
  time = Number(time);
  if (time < 10000000000) {
    //说明时间戳是秒
    time *= 1000;
  }
  const date = new Date(time);
  const YY = date.getFullYear();
  const MM = addZero(date.getMonth() + 1);
  const DD = addZero(date.getDate());
  const hh = addZero(date.getHours());
  const mm = addZero(date.getMinutes());
  const ss = addZero(date.getSeconds());
  // 将时间从24小时格式转换为AM / PM格式
  // let Ap = Number(hh) < 12 ? 'AM' : 'PM'
  // let ApHH = Number(hh) < 12 ? hh : Number(hh) - 12
  switch (type) {
    case 1:
      return `${YY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
    case 2:
      return `${YY}-${MM}-${DD} ${hh}:${mm}`;
    case 3:
      return `${YY}-${MM}-${DD} ${hh}`;
    case 4:
      return `${YY}-${MM}-${DD}`;
    case 5:
      return `${MM}-${DD}`;
    case 6:
      return `${mm}:${ss}`;
    case 7:
      return `${MM}-${DD} ${hh}:${mm}`;
    case 8:
      return `${hh}:${mm}:${ss}`;
    case 9:
      return `${hh}:${mm}`;
    case 10:
      return `${Number(hh) < 12 ? hh : Number(hh) - 12}:${mm}${Number(hh) < 12 ? "AM" : "PM"}`;
    case 11:
      return `${MM}-${DD} ${hh}:${mm}:${ss}`;
    case 12:
      return `${MM}/${DD}/${YY}`;
    case 13:
      return `${hh}:${mm} ${MM}-${DD}`;
    default:
      return `${YY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
  }
};
/**
 * @param seconds
 * @returns FormatTime(1004); // 输出: "00:16:44"
 */
export function formatTime(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return [h, m, s].map((unit) => String(unit).padStart(2, "0")).join(":");
}

export function formatTimestamp(timestamp: number) {
  // 如果是秒级（10位），转换成毫秒级（13位）
  if (String(timestamp).length === 10) {
    timestamp *= 1000;
  }

  const date = new Date(timestamp);
  const y = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${y}-${month}-${day} ${hours}:${minutes}`;
}

/**
 * 格式化时间
 *
 * @param time 时间戳 毫秒
 * @param format 格式
 * @returns 格式化后的时间
 */
export const formatTimeDayjs = (
  time: number,
  format: string = "YYYY-MM-DD HH:mm:ss",
) => {
  return dayjs(time).format(format);
};

/**
 * 获取当前时间戳-服务器时间戳（秒）
 *
 * @param type 1: 秒级时间戳 2: 毫秒级时间戳
 * @returns 时间戳（秒）
 */
export const getServerTimestamp = (type: number = 1): number => {
  const timestamp = Math.floor(Date.now() / 1000);
  const timeOffset = sysConfigStore.timeOffset;
  if (type === 1) {
    return timestamp - timeOffset;
  }
  return (timestamp - timeOffset) * 1000;
};
